import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Bottom tab bar for the mobile workspace. Uses the exact same
 * navigate('/agent/workspace/{param}') pattern as desktop's pill
 * buttons in AgentWorkspace.jsx, so switching tabs behaves identically
 * (same route, same params, same effects that reload the contact list).
 */
const TABS = [
  { param: "cold-calls", labelKey: "agent.cards.coldCalls" },
  { param: "follow-up", labelKey: "agent.cards.FollowUp" },
  { param: "meeting", labelKey: "agent.cards.Meeting" },
  { param: "meeting-recovery", labelKey: "agent.cards.MeetingRecovery" },
];

const TabIcon = ({ param, active }) => {
  const color = active ? "white" : "#8892B0";
  if (param === "cold-calls") {
    return (
      <svg viewBox="0 0 24 24" fill="none" width="17" height="17">
        <path d="M15 8a3 3 0 0 1 3 3M15 4a7 7 0 0 1 7 7m-1.5 10.5a17 17 0 0 1-15-15c0-.9.6-1.7 1.4-2l3-1.2a1.6 1.6 0 0 1 2 .8l1.4 3.1a1.6 1.6 0 0 1-.4 1.9l-1.4 1.2a13 13 0 0 0 5.9 5.9l1.2-1.4a1.6 1.6 0 0 1 1.9-.4l3.1 1.4a1.6 1.6 0 0 1 .8 2z" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (param === "follow-up") {
    return (
      <svg viewBox="0 0 24 24" fill="none" width="17" height="17">
        <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z" stroke={color} strokeWidth="1.7" strokeLinejoin="round" />
        <path d="M14 3v6h6M8 13h8M8 17h5" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
      </svg>
    );
  }
  if (param === "meeting") {
    return (
      <svg viewBox="0 0 24 24" fill="none" width="17" height="17">
        <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="1.7" />
        <path d="M8 3v4M16 3v4M3 10h18" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" width="17" height="17">
      <rect x="3" y="4" width="18" height="16" rx="2" stroke={color} strokeWidth="1.7" />
      <path d="m8 13 2.5 2.5L16 10" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const MobileTabBar = ({ activeCallType, counts }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex bg-white border-t border-gray-200 px-1 py-1.5 flex-shrink-0">
      {TABS.map((tab) => {
        const active = activeCallType === tab.param;
        const count = counts?.[tab.param] || 0;
        return (
          <button
            key={tab.param}
            type="button"
            onClick={() => navigate(`/agent/workspace/${tab.param}`)}
            className={`flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-xl relative ${
              active ? "bg-icon" : ""
            }`}
          >
            <TabIcon param={tab.param} active={active} />
            <span
              className={`text-[8.5px] font-bold leading-tight text-center px-0.5 ${
                active ? "text-white" : "text-gray-400"
              }`}
            >
              {t(tab.labelKey)}
            </span>
            {count > 0 && (
              <span className="absolute -top-1 right-1.5 bg-tertiary text-icon-dark text-[9px] font-extrabold min-w-[15px] h-[15px] rounded-full flex items-center justify-center border-2 border-white px-0.5">
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default MobileTabBar;